// extracted by mini-css-extract-plugin
module.exports = {"title":"card-info_title_1QDiq","dot":"card-info_dot_1G8F8"};